/* es5-ext/object/for-each */ function _(require, module, exports) {
    module.exports = require(338) /* ./_iterate */("forEach");
}
